import { render, staticRenderFns } from "./card_list.vue?vue&type=template&id=2a659cc2&scoped=true&"
import script from "./card_list.vue?vue&type=script&lang=js&"
export * from "./card_list.vue?vue&type=script&lang=js&"
import style0 from "./card_list.vue?vue&type=style&index=0&id=2a659cc2&scoped=true&lang=less&"
import style1 from "./card_list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a659cc2",
  null
  
)

export default component.exports